import { render } from "./FaqContactTemplate.vue?vue&type=template&id=b1530400&scoped=true&ts=true"
import script from "./FaqContactTemplate.vue?vue&type=script&lang=ts"
export * from "./FaqContactTemplate.vue?vue&type=script&lang=ts"

import "./FaqContactTemplate.vue?vue&type=style&index=0&id=b1530400&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1530400"]])

export default __exports__